<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="addItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-card>
                <template slot="header">
                  Chili Template toevoegen
                </template>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Sectie">
                      <b-form-radio-group
                        id="radio-group-1"
                        v-model="item.section"
                      >
                        <b-form-radio value="content">Landelijke content</b-form-radio>
                        <b-form-radio value="links">links</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Naam">
                      <b-form-input type="text" required v-model="item.name"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="item.section === 'content'">
                  <b-col cols="12" md="6">
                    <b-form-group label="Thumbail">
                      <b-form-file v-model="featuredImageFile" placeholder="Selecteer een bestand..."></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Type">
                      <b-form-radio-group
                        id="radio-group-2"
                        v-model="item.type"
                      >
                        <b-form-radio value="file">bestand</b-form-radio>
                        <b-form-radio value="link">link</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="item.type === 'file'">
                  <b-col cols="12" md="6">
                    <b-form-group label="Bestand">
                      <b-form-file v-model="file" placeholder="Selecteer een bestand..."></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="item.type == 'link'">
                  <b-col cols="12" md="6">
                    <b-form-group label="Link">
                      <b-form-input type="text" required v-model="item.link"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <template slot="footer">
                    <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Toevoegen</b-button>
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { addData } from '../../api';

  export default {
    name: 'download',

    data() {
      return {
        saveButtonDisabled: false,
        item: {
          section: 'content',
          type: 'file',
        },
        file: null,
        featuredImageFile: null,
      };
    },

    methods: {
      async addItem() {
        this.saveButtonDisabled = true;

        let formData = new FormData();
        Object.keys(this.item).forEach(key => {
          formData.append(key, this.item[key]);
        });

        const request = await addData('downloads', formData);

        if (request.status === 201) {
          this.$router.push({ name: 'downloads.view', params: { id: request.data.data.id } });
        } else {
          this.saveButtonDisabled = false;
        }
      },
    },
    watch: {
      'featuredImageFile'(newValue) {
        this.item.new_featured_image = newValue;
      },
      'file'(newValue) {
        this.item.new_file = newValue;
      }
    },
  };
</script>
